/**
 * API服务层
 * @module api/services
 */
import { bilibiliResources } from '../data/bilibiliResources';

/**
 * B站资源相关API - 使用Mock数据
 */
export const bilibiliApi = {
    /**
     * 获取B站资源列表
     * @returns {Promise} B站资源列表数据
     */
    getResources() {
        // 直接返回mock数据，模拟API请求
        return Promise.resolve(bilibiliResources);
    },
    
    /**
     * 获取B站资源详情
     * @param {string} id - 资源ID
     * @returns {Promise} B站资源详情数据
     */
    getResourceDetail(id) {
        // 从mock数据中查找特定ID的资源分类
        const resource = bilibiliResources.find(resource => resource.id === id);
        if (resource) {
            return Promise.resolve(resource);
        } else {
            return Promise.reject(new Error('资源不存在'));
        }
    }
};
